import { c as _c } from "react/compiler-runtime";
import { APIDestination } from '../../../../../../../../typings/Destination.interface';
import Container from '../../../../common/base/Container';
import ResourceMetricSection from '../ResourceMetricsSection';
export const DestinationMetrics = t0 => {
  const $ = _c(2);
  const {
    destination
  } = t0;
  let t1;
  if ($[0] !== destination.id) {
    t1 = <Container left={true}><ResourceMetricSection id={destination.id} resource="destinations" default_relative_date="last_hour" /></Container>;
    $[0] = destination.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};